import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/filter/car.svg'
import _imports_1 from '../../../assets/filter/box.svg'


const _withScopeId = n => (_pushScopeId("data-v-041cfc80"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "modais" }
const _hoisted_2 = {
  class: "modal fade",
  id: "inserirSelecionados",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "exampleModalCenterTitle",
  "aria-hidden": "true"
}
const _hoisted_3 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", {
    class: "modal-title",
    id: "exampleModalLongTitle"
  }, "Adicionar produtos nos veículos selecionados"),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1))
const _hoisted_6 = {
  class: "modal-body",
  id: "modalBody"
}
const _hoisted_7 = { class: "card d-flex flex-row" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_9 = {
  class: "w-100",
  id: "ulPaiListaCard"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "titulosDoModal" }, "Veiculos selecionados", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { id: "pontoLista" }, null, -1))
const _hoisted_12 = {
  class: "d-flex flex-row w-100",
  id: "listaVeiculosDoModal"
}
const _hoisted_13 = /*#__PURE__*/_createStaticVNode("<div class=\"card d-flex flex-row mt-4\" data-v-041cfc80><img src=\"" + _imports_1 + "\" alt=\"\" style=\"padding-right:1.9rem;\" data-v-041cfc80><div class=\"w-100 d-flex flex-column\" id=\"ulPaiListaCard\" data-v-041cfc80><h6 class=\"titulosDoModal\" data-v-041cfc80>Produto</h6><select class=\"mb-3\" id=\"selectModal\" data-v-041cfc80><option value=\"\" data-v-041cfc80>Oleo Lubrificante</option></select><select name=\"\" id=\"selectModal\" data-v-041cfc80></select></div></div>", 1)
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-footer" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn",
    "data-bs-dismiss": "modal"
  }, "Adicionar nos veiculos")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("ul", _hoisted_9, [
                _hoisted_10,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.clickedAllVeiculos, (myCarsAndOptions, key) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: key,
                    id: "listaDoCard",
                    class: "d-flex flex-row justify-content-around align-items-center w-100"
                  }, [
                    _hoisted_11,
                    _createElementVNode("span", _hoisted_12, _toDisplayString(myCarsAndOptions.marca) + " - " + _toDisplayString(myCarsAndOptions.modelo), 1)
                  ]))
                }), 128))
              ])
            ]),
            _hoisted_13
          ]),
          _hoisted_14
        ])
      ])
    ])
  ]))
}